import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Mimecast } from "@graylog/enterprise-api";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import formValidation from "../common/utils/formValidation";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { connectionString } = formData;
  const handleSubmit = () => {
    var _a, _b, _c, _d, _e;
    const fetcher = Mimecast.checkCredentials({
      base_url: ((_a = formData == null ? void 0 : formData.baseUrl) == null ? void 0 : _a.value) || "",
      access_key: ((_b = formData == null ? void 0 : formData.accessKey) == null ? void 0 : _b.value) || "",
      secret_key: ((_c = formData == null ? void 0 : formData.secretKey) == null ? void 0 : _c.value) || "",
      application_id: ((_d = formData == null ? void 0 : formData.applicationId) == null ? void 0 : _d.value) || "",
      application_key: ((_e = formData == null ? void 0 : formData.applicationKey) == null ? void 0 : _e.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: t("mimecast.errors.unable_to_connect")
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: t("mimecast.errors.unable_to_connect")
      });
    });
  };
  const isFormValid = formValidation.isFormValid(
    ["mimecastName", "baseUrl", "accessKey", "secretKey", "applicationId", "applicationKey"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.verify_connection_and_proceed"),
      disabled: isFormValid,
      className: "col-md-7",
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "mimecastName",
        type: "text",
        fieldData: formData.mimecastName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "baseUrl",
        type: "text",
        fieldData: formData.baseUrl,
        onChange,
        label: t("mimecast.authorize.base_url"),
        help: t("mimecast.authorize.base_url_help"),
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "applicationId",
        type: "text",
        onChange,
        fieldData: formData.applicationId,
        label: t("mimecast.authorize.application_id"),
        help: t("mimecast.authorize.application_id_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "applicationKey",
        type: "password",
        onChange,
        fieldData: formData.applicationKey,
        label: t("mimecast.authorize.application_key"),
        help: t("mimecast.authorize.application_key_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "accessKey",
        type: "text",
        onChange,
        fieldData: formData.accessKey,
        label: t("mimecast.authorize.access_key"),
        help: t("mimecast.authorize.access_key_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "secretKey",
        type: "password",
        onChange,
        fieldData: formData.secretKey,
        label: t("mimecast.authorize.secret_key"),
        help: t("mimecast.authorize.secret_key_help"),
        required: true
      }
    )
  );
};
export default StepAuthorize;
